import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en';

export const defaultNS = 'translation';

export const resources = {
  en: { translation: en },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  defaultNS,
  initAsync: false,
  interpolation: { escapeValue: false },
});

export default i18n;
